/**
 * PULSE Add-To-Cart (standalone)
 * ------------------------------------------------------------
 * Independent of the cart drawer. Handles every add-to-cart on
 * the site with real error handling, so a failed add is never
 * reported as success.
 *
 * window.PulseCart.add(variantId, qty, properties)
 */
(function(){

  function addToCart(variantId, quantity, properties){
    var item = { id: variantId, quantity: quantity || 1 };
    if(properties && Object.keys(properties).length){
      item.properties = properties;
    }
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function(res){
      return res.json().then(function(data){
        if(!res.ok){
          var msg = (data && (data.description || data.message)) || ('Add failed (' + res.status + ')');
          throw new Error(msg);
        }
        return data;
      });
    });
  }

  function openDrawer(){
    var overlay = document.getElementById('CartOverlay');
    if(!overlay) return false;
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    window.dispatchEvent(new CustomEvent('pulse:cart-updated'));
    return true;
  }

  function flash(btn, text, isError){
    var original = btn.dataset.originalLabel || btn.textContent.trim();
    btn.dataset.originalLabel = original;
    btn.textContent = text;
    btn.classList.toggle('is-error', !!isError);
    setTimeout(function(){
      btn.textContent = original;
      btn.disabled = false;
      btn.classList.remove('is-error');
      var card = btn.closest('.upsell-card');
      if(card) card.classList.remove('is-added');
    }, isError ? 2600 : 1600);
  }

  /* ---- Upsell card buttons ----
     Bundles needing a size mix carry data-bundle-size and are
     handled by pulse-bundle-mix.js in the capture phase. */
  document.addEventListener('click', function(e){
    var btn = e.target.closest('button.upsell-card-add');
    if(!btn || btn.disabled) return;
    if(btn.hasAttribute('data-bundle-size')) return;
    e.preventDefault();

    var variantId = btn.getAttribute('data-variant-id');
    if(!variantId){ console.warn('PULSE: upsell button missing variant id'); return; }

    var card = btn.closest('.upsell-card');
    btn.dataset.originalLabel = btn.dataset.originalLabel || btn.textContent.trim();
    btn.disabled = true;
    btn.textContent = 'Adding…';

    addToCart(variantId, 1)
      .then(function(){
        if(card) card.classList.add('is-added');
        flash(btn, 'Added ✓', false);
        openDrawer();
      })
      .catch(function(err){
        console.error('PULSE add-to-cart failed:', err);
        flash(btn, 'Unavailable', true);
      });
  });

  /* ---- Any product add-to-cart form ----
     Matched on the form's action rather than an id. Shopify's
     {% form 'product' %} tag does not reliably apply a custom id,
     which previously let this submit natively and redirect away
     instead of opening the drawer.

     NOTE on nativeSubmit(): never call form.submit() directly.
     HTML exposes a form's fields as properties on the form object
     by name, so a field named "submit" (or "id", "action", ...)
     shadows the native property — our product form already does
     this with <input name="id">. Going through the prototype is
     immune to that. */
  function nativeSubmit(form){
    HTMLFormElement.prototype.submit.call(form);
  }

  function isAddToCartForm(form){
    if(!form || form.tagName !== 'FORM') return false;
    var action = form.getAttribute('action') || '';
    if(action.indexOf('/cart/add') !== -1) return true;
    // Fallback: our product form always contains this input
    return !!form.querySelector('#ProductVariantId');
  }

  document.addEventListener('submit', function(e){
    var form = e.target;
    if(!isAddToCartForm(form)) return;

    e.preventDefault();

    var submitBtn = form.querySelector('[type="submit"]') || document.getElementById('ProductSubmit');
    var idInput = form.querySelector('[name="id"]') || document.getElementById('ProductVariantId');
    var qtyInput = form.querySelector('[name="quantity"]');
    var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;

    if(!idInput || !idInput.value){
      console.warn('PULSE: no variant id on form, falling back to native submit');
      nativeSubmit(form);
      return;
    }

    var original = submitBtn ? submitBtn.textContent.trim() : '';
    if(submitBtn){
      submitBtn.disabled = true;
      submitBtn.textContent = 'Adding…';
    }

    addToCart(idInput.value, qty)
      .then(function(){
        if(submitBtn){
          submitBtn.textContent = original;
          submitBtn.disabled = false;
        }
        openDrawer();
      })
      .catch(function(err){
        console.error('PULSE add-to-cart failed:', err);
        if(submitBtn){
          submitBtn.textContent = original;
          submitBtn.disabled = false;
        }
        // Last resort: let the browser do a real add so the customer
        // is never stuck with a dead button.
        nativeSubmit(form);
      });
  });

  window.PulseCart = { add: addToCart, openDrawer: openDrawer };
})();
